import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const HtmlTooltipTheme = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

export default function HtmlTooltip(props) {
    const { title, ...other } = props;
    return (
        <div>
            <HtmlTooltipTheme
                title={title}
                {...other}
            >
            </HtmlTooltipTheme>
        </div>
    );
}